function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rg)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.42801 93.085H100.19L93.753 36.84H0L6.42801 93.085Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.154 88.287H103.907L97.475 32.042H3.72198L10.154 88.287Z",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.616 109.61L48.178 88.287H63.168L65.606 109.61H50.616Z",
  stroke: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.108 61.493V103.086L184.03 117.568V71.242C184.031 63.2575 181.355 55.5033 176.429 49.2197C171.502 42.936 164.611 38.4862 156.857 36.582H156.865C153.089 35.6518 149.15 35.5929 145.348 36.4098C141.545 37.2267 137.979 38.898 134.918 41.2971C131.857 43.6962 129.382 46.7603 127.68 50.2574C125.978 53.7544 125.094 57.5928 125.095 61.482L125.108 61.493Z",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.663 109.609H2.36798",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.911 42.814C169.911 42.814 194.203 62.763 200.311 94.994C206.419 127.225 158.011 119.485 134.973 109.994",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.184 42.814C133.184 42.814 115.995 60.547 111.457 93.084C111.457 93.084 94.025 93.684 93.328 107.384",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.51 12.985V19.628C140.51 22.1231 141.347 24.546 142.886 26.5097C144.425 28.4734 146.578 29.8646 149.001 30.461L159.572 33.054V7.09201L150.784 4.93201C149.563 4.63299 148.29 4.6153 147.061 4.8803C145.832 5.14529 144.679 5.68605 143.689 6.46172C142.7 7.23739 141.9 8.22772 141.349 9.35794C140.798 10.4882 140.511 11.7287 140.51 12.986V12.985Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.51 19.627C140.51 22.1221 141.347 24.5451 142.886 26.5089C144.425 28.4727 146.578 29.8638 149.001 30.46L159.572 33.053",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.338 18.43C151.652 18.43 151.907 18.1752 151.907 17.861C151.907 17.5467 151.652 17.292 151.338 17.292C151.024 17.292 150.769 17.5467 150.769 17.861C150.769 18.1752 151.024 18.43 151.338 18.43Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.51 18.43C143.824 18.43 144.079 18.1752 144.079 17.861C144.079 17.5467 143.824 17.292 143.51 17.292C143.196 17.292 142.941 17.5467 142.941 17.861C142.941 18.1752 143.196 18.43 143.51 18.43Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.746 20.841V12.984",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.318 17.01V19.739C159.025 19.7387 159.703 19.4577 160.202 18.9578C160.702 18.4578 160.983 17.7799 160.983 17.073V16.832C160.936 16.497 160.764 16.1921 160.501 15.9788C160.239 15.7654 159.905 15.6594 159.568 15.6819C159.23 15.7045 158.914 15.854 158.682 16.1003C158.45 16.3467 158.32 16.6717 158.318 17.01Z",
  fill: "#FFE1DE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.318 19.74C159.025 19.7397 159.703 19.4587 160.202 18.9588C160.702 18.4588 160.983 17.7809 160.983 17.074",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.881 23.399C148.045 23.5628 148.239 23.6928 148.453 23.7814C148.667 23.8701 148.896 23.9157 149.128 23.9157C149.36 23.9157 149.589 23.8701 149.803 23.7814C150.017 23.6928 150.211 23.5628 150.375 23.399",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.746 20.848L147.465 21.271",
  stroke: "#131313",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.882 30.124C147.882 30.124 149.753 38.197 144.356 41.46C143.93 41.7238 143.578 42.0916 143.333 42.529C143.088 42.9663 142.958 43.4588 142.956 43.96C142.905 48.046 142.022 57.491 134.856 56.214C129.001 55.172 130.675 45.171 132.616 38.162C133.832 33.7809 134.329 29.2314 134.087 24.691C133.587 15.138 135.25 -1.209 152.997 0.644002C155.63 0.886199 158.17 1.74245 160.412 3.144C165.003 6.099 170.127 12.675 159.573 25.533",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.51 15.367C140.51 15.367 152.541 17.702 154.4 10.335C154.4 10.335 155.328 15.555 158.368 16.629",
  stroke: "#131313",
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 201.342,
  height: 118.773,
  fill: "white"
})));

var SvgRegisterGirl = function SvgRegisterGirl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 119,
    viewBox: "0 0 202 119",
    fill: "none",
    className: "sm:hidden absolute top-0 right-0 mt-28 ml-4 -mr-4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegisterGirl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/registerGirl.4e854995.svg";
export { ForwardRef as ReactComponent };